export default __webpack_public_path__ + "static/media/marked_clock.9ab808f0.svg";